<div class="pc-page-shell">
  <div class="filter-container" [class.open]="isFilterOpen">
    <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode(), 'light-filter': !isDarkMode() }">
      <div class="filter-header">
        <div class="filter-header__title">
          <mat-icon aria-hidden="true">filter_alt</mat-icon>
          <span>Table Filter</span>
        </div>
        <mat-icon class="close-btn" (click)="closeFilterDrawer()">close</mat-icon>
      </div>

      <form [formGroup]="filterForm" class="filter-body">
        <div class="filter-section">
          <h4>Date Range</h4>
          <app-custom-date-picker
            [label]="'From Date'"
            [controlname]="filterForm.controls['from_date']">
          </app-custom-date-picker>
          <app-custom-date-picker
            [label]="'To Date'"
            [controlname]="filterForm.controls['to_date']">
          </app-custom-date-picker>
        </div>

        <div class="filter-section">
          <h4>Vessel Name</h4>
          <app-pc-multi-select-filter
            [lightMode]="!isDarkMode()"
            label=""
            placeholder="Select Vessel"
            allLabel="All"
            [options]="vesselFilterOptions"
            [(selected)]="selectedVessels">
          </app-pc-multi-select-filter>
        </div>

        <div class="filter-section">
          <h4>Status</h4>
          <app-pc-multi-select-filter
            [lightMode]="!isDarkMode()"
            label=""
            placeholder="Select Status"
            allLabel="All"
            [options]="statusFilterOptions"
            [(selected)]="selectedStatuses">
          </app-pc-multi-select-filter>
        </div>

        <div class="filter-section">
          <h4>Uploaded By</h4>
          <app-pc-multi-select-filter
            [lightMode]="!isDarkMode()"
            label=""
            placeholder="Select Uploaded By"
            allLabel="All"
            [options]="uploadedByOptions"
            [(selected)]="selectedUploadedBy">
          </app-pc-multi-select-filter>
        </div>
      </form>

      <div class="filter-footer">
        <button type="button" class="btn clear-btn" (click)="clearClick()">
          <mat-icon>clear_all</mat-icon>
          Clear Filter
        </button>
        <button type="button" class="btn apply-btn" (click)="filterClick()">
          <mat-icon>filter_list</mat-icon>
          Apply Filter
        </button>
      </div>
    </div>
  </div>
  <div class="filter-overlay" *ngIf="isFilterOpen" (click)="closeFilterDrawer()"></div>

  <div
    class="container pc-performance-page vot-page"
    [class.vot-page--preview-open]="previewOpen"
    (click)="closeActionMenus()"
  >
    <header class="pc-page-header">
      <p class="title pc-page-header__title">
        Port Performance <mat-icon class="titleIcon">chevron_right</mat-icon> Vessel Overspend Tracker
        <mat-icon class="titleIcon">chevron_right</mat-icon>
      </p>
      <div class="pc-page-header__actions">
        <button
          type="button"
          class="pc-page-header__filter-btn"
          [class.pc-page-header__filter-btn--active]="hasActiveFilters"
          (click)="openFilterDrawer()"
          matTooltip="Table Filter"
          aria-label="Open table filters"
        >
          <mat-icon>filter_list</mat-icon>
        </button>
      </div>
    </header>

    <div class="vot-layout">
      <div class="vot-layout__main">
        <div class="pc-performance-table-stack vot-record-stack">
          <div class="table-view-banner view-active table-view-banner--nested">
            <mat-icon>note_add</mat-icon>
            <div class="banner-copy">
              <span class="banner-title">Add New Record</span>
              <span class="banner-subtitle">
                Capture vessel details and attach supporting overspend documentation.
              </span>
            </div>
          </div>

          <div class="vot-record-panel">
            <form [formGroup]="recordForm" class="vot-record-form">
              <div class="vot-record-fields">
                <div class="vot-record-field vot-record-field--vessel">
                  <label class="vot-field-label" for="vot-vessel-name">Vessel Name</label>
                  <input
                    id="vot-vessel-name"
                    type="text"
                    class="form-control"
                    formControlName="vesselName"
                    autocomplete="off"
                    [placeholder]="isLoadingVessels ? 'Loading vessels...' : 'Search vessel name'"
                    [matAutocomplete]="vesselAuto"
                    (focus)="onVesselNameFocus()"
                    (input)="onVesselNameInput($event)"
                  />
                  <mat-autocomplete
                    #vesselAuto="matAutocomplete"
                    panelClass="vot-vessel-autocomplete-panel"
                    (optionSelected)="onVesselSelected($event)"
                  >
                    <mat-option *ngIf="showNoVesselSuggestions" disabled>
                      No matching vessels found
                    </mat-option>
                    <mat-option
                      *ngFor="let vessel of filteredVesselSuggestions"
                      [value]="vessel.vessel_name"
                    >
                      {{ vessel.vessel_name }}
                    </mat-option>
                  </mat-autocomplete>
                </div>

                <div class="vot-record-field">
                  <label class="vot-field-label">I.M.O Number</label>
                  <app-custom-input
                    placeholder="I.M.O Number"
                    label=""
                    [readonly]="true"
                    [controlname]="recordForm.controls['imoNumber']">
                  </app-custom-input>
                </div>

                <div class="vot-record-field">
                  <label class="vot-field-label" for="vot-category">Category</label>
                  <select id="vot-category" class="form-control" formControlName="category">
                    <option value="">Optional</option>
                    <option *ngFor="let c of categories" [value]="c">{{ c }}</option>
                  </select>
                </div>

                <div class="vot-record-field">
                  <label class="vot-field-label" for="vot-priority">Priority</label>
                  <select id="vot-priority" class="form-control" formControlName="priority">
                    <option *ngFor="let p of priorities" [value]="p">{{ p }}</option>
                  </select>
                </div>
              </div>

              <div class="vot-record-upload">
                <label class="vot-field-label">Upload Document</label>
                <div
                  class="vot-upload-box"
                  [class.vot-upload-box--active]="isDragOver"
                  [class.vot-upload-box--filled]="!!selectedFile"
                  (dragover)="onDragOver($event)"
                  (dragleave)="onDragLeave($event)"
                  (drop)="onDrop($event)"
                  (click)="fileInput.click()"
                >
                  <mat-icon>cloud_upload</mat-icon>
                  <p class="vot-upload-box__title" *ngIf="!selectedFile">
                    Drag & drop or click to upload
                  </p>
                  <p class="vot-upload-box__title" *ngIf="selectedFile">
                    {{ selectedFile.name }}
                  </p>
                  <p class="vot-upload-box__hint">PDF, DOC, DOCX · Max. 20MB</p>

                  <div class="vot-progress" *ngIf="isUploading || (uploadProgress === 100 && selectedFile)">
                    <div class="vot-progress__bar">
                      <span [style.width.%]="uploadProgress"></span>
                    </div>
                    <span class="vot-progress__label">{{ uploadProgress }}%</span>
                  </div>

                  <button
                    type="button"
                    class="btn btn-light hover-button mail vot-upload-box__clear"
                    *ngIf="selectedFile"
                    (click)="clearSelectedFile(fileInput); $event.stopPropagation()"
                  >
                    <mat-icon>close</mat-icon> Clear
                  </button>
                </div>
                <input
                  #fileInput
                  type="file"
                  hidden
                  accept=".pdf,.doc,.docx"
                  (change)="onFileSelected($event)"
                />
              </div>

              <div class="text-right vot-record-actions">
                <button
                  type="button"
                  class="btn btn-light hover-button apply"
                  (click)="submitRecord(fileInput); $event.stopPropagation()"
                >
                  <mat-icon>done</mat-icon> Submit
                </button>
              </div>
            </form>
          </div>
        </div>

        <div class="pc-performance-table-stack vot-table-stack">
          <div class="table-view-banner view-active table-view-banner--nested">
            <mat-icon>table_chart</mat-icon>
            <div class="banner-copy">
              <span class="banner-title" id="vot-table-title">Uploaded Records</span>
            </div>
            <span class="banner-count">{{ filteredRecords.length || 0 }} records</span>
          </div>

          <div class="detail-rail-table-wrapper pc-performance-table-wrapper">
            <div
              class="detail-rail-table-scroll table-container scroll-bar pc-performance-table-scroll pc-data-table"
              [class.pc-data-table--dark]="isDarkMode()"
            >
              <table
                class="pc-performance-table mat-elevation-z8 printable-table"
                [ngClass]="{ 'dark-table': isDarkMode() }"
              >
                <thead class="sticky-header">
                  <tr>
                    <th class="th-text-center2 centersno">#</th>
                    <th class="th-text-center3" (click)="setSort('vesselName')">
                      <span class="pc-col-header">
                        <span class="pc-col-header__label">Vessel</span>
                      </span>
                    </th>
                    <th class="th-text-center2" (click)="setSort('imoNumber')">
                      <span class="pc-col-header">
                        <span class="pc-col-header__label">IMO</span>
                      </span>
                    </th>
                    <th class="th-text-center">
                      <span class="pc-col-header">
                        <span class="pc-col-header__label">File Name</span>
                      </span>
                    </th>
                    <th class="th-text-center" (click)="setSort('uploadDate')">
                      <span class="pc-col-header">
                        <span class="pc-col-header__label">Upload Date</span>
                      </span>
                    </th>
                    <th class="th-text-center">
                      <span class="pc-col-header">
                        <span class="pc-col-header__label">Uploaded By</span>
                      </span>
                    </th>
                    <th class="th-text-center">
                      <span class="pc-col-header">
                        <span class="pc-col-header__label">Status</span>
                      </span>
                    </th>
                    <th class="th-text-center">
                      <span class="pc-col-header">
                        <span class="pc-col-header__label">Actions</span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of pagedRecords; let i = index">
                    <td class="centersno">{{ pageStart + i }}</td>
                    <td>{{ row.vesselName }}</td>
                    <td>{{ row.imoNumber }}</td>
                    <td>
                      <div class="vot-file-cell">
                        <mat-icon
                          [class.vot-file-icon--pdf]="fileIcon(row.fileName) === 'picture_as_pdf'"
                        >
                          {{ fileIcon(row.fileName) }}
                        </mat-icon>
                        <span>{{ row.fileName }}</span>
                      </div>
                    </td>
                    <td>{{ row.uploadDate }}</td>
                    <td>{{ row.uploadedBy }}</td>
                    <td>
                      <span class="vot-badge" [ngClass]="statusClass(row.status)">
                        {{ row.status }}
                      </span>
                    </td>
                    <td>
                      <div class="vot-row-actions">
                        <button
                          type="button"
                          class="gradient-btn"
                          (click)="viewDocument(row); $event.stopPropagation()"
                          [ngStyle]="{
                            'background-image': 'linear-gradient(98deg, #0046de, #006063)',
                            'border-radius': '11px',
                            border: 'none'
                          }"
                          matTooltip="View"
                        >
                          <mat-icon
                            fontSet="material-icons-outlined"
                            fontIcon="visibility"
                            class="visiblityIcon"
                          >visibility_outlined</mat-icon>
                        </button>
                        <div class="vot-more">
                          <button
                            type="button"
                            class="vot-icon-btn"
                            (click)="toggleActionMenu(row.id, $event)"
                            aria-label="More actions"
                          >
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <div
                            class="vot-menu"
                            *ngIf="actionMenuId === row.id"
                            (click)="$event.stopPropagation()"
                          >
                            <button type="button" (click)="viewDocument(row)">
                              <mat-icon>visibility</mat-icon> Preview
                            </button>
                            <button type="button" (click)="downloadDocument(row)">
                              <mat-icon>download</mat-icon> Download
                            </button>
                            <button
                              type="button"
                              class="vot-menu__danger"
                              (click)="deleteRecord(row)"
                            >
                              <mat-icon>delete</mat-icon> Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="!pagedRecords.length">
                    <td colspan="8" class="vot-table__empty">No records match your filters.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        <div class="vot-table-footer" *ngIf="filteredRecords.length">
          <span class="vot-muted">
            Showing {{ pageStart }} to {{ pageEnd }} of {{ filteredRecords.length }} records
          </span>
          <div class="vot-table-footer__actions">
            <button
              type="button"
              class="btn btn-light hover-button mail vot-download-csv-btn"
              (click)="exportRecords()"
            >
              <mat-icon>download</mat-icon>
              Download CSV
            </button>
            <div class="vot-pagination__controls">
              <button
                type="button"
                class="vot-icon-btn"
                [disabled]="pageIndex === 0"
                (click)="goToPage(pageIndex - 1)"
              >
                <mat-icon>chevron_left</mat-icon>
              </button>
              <button
                type="button"
                class="vot-page-btn"
                *ngFor="let p of pageNumbers"
                [class.vot-page-btn--active]="p === pageIndex"
                (click)="goToPage(p)"
              >
                {{ p + 1 }}
              </button>
              <button
                type="button"
                class="vot-icon-btn"
                [disabled]="pageIndex >= totalPages - 1"
                (click)="goToPage(pageIndex + 1)"
              >
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <aside
      class="vot-preview vot-animate-in vot-animate-in--delay-2"
      [class.vot-preview--open]="previewOpen"
      [class.vot-preview--fullscreen]="previewFullscreen"
      *ngIf="previewOpen"
      role="complementary"
      aria-label="Document preview"
    >
      <header class="vot-preview__header">
        <div class="vot-preview__file">
          <mat-icon class="vot-preview__pdf-icon">picture_as_pdf</mat-icon>
          <div>
            <div class="vot-preview__name">{{ previewFileName || 'Document Preview' }}</div>
            <div class="vot-preview__meta" *ngIf="previewFileSize">{{ previewFileSize }}</div>
          </div>
        </div>
        <div class="vot-preview__actions">
          <a
            class="vot-icon-btn"
            [href]="previewRawUrl"
            download
            target="_blank"
            rel="noopener"
            matTooltip="Download"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>download</mat-icon>
          </a>
          <button
            type="button"
            class="vot-icon-btn"
            (click)="toggleFullscreen(); $event.stopPropagation()"
            matTooltip="Fullscreen"
          >
            <mat-icon>{{ previewFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
          </button>
          <button
            type="button"
            class="vot-icon-btn"
            (click)="closePreview(); $event.stopPropagation()"
            aria-label="Close preview"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </header>

      <div class="vot-preview__toolbar">
        <button type="button" class="vot-icon-btn" (click)="zoomOut()" matTooltip="Zoom out">
          <mat-icon>remove</mat-icon>
        </button>
        <button type="button" class="vot-zoom-label" (click)="resetZoom()">
          {{ zoomLevel }}%
        </button>
        <button type="button" class="vot-icon-btn" (click)="zoomIn()" matTooltip="Zoom in">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <div class="vot-preview__body">
        <iframe
          *ngIf="previewIsPdf && previewSafeUrl"
          class="vot-preview__frame"
          [src]="previewSafeUrl"
          [style.transform]="'scale(' + zoomLevel / 100 + ')'"
          title="Document preview"
        ></iframe>
        <div class="vot-preview__fallback" *ngIf="!previewIsPdf && previewSafeUrl">
          <mat-icon>description</mat-icon>
          <p>Inline preview is available for PDF files.</p>
          <a
            class="btn btn-light hover-button apply"
            [href]="previewRawUrl"
            target="_blank"
            rel="noopener"
          >
            Open Document
          </a>
        </div>
      </div>

    </aside>
    </div>
  </div>
</div>
